import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "25",
  fill: "currentColor",
  viewBox: "0 0 50 50"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "3",
  d: "M36 38.002H12c-3.4 0-6-2.6-6-6v-16c0-3.4 2.6-6 6-6h24c3.4 0 6 2.6 6 6v16c0 3.4-2.6 6-6 6"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.349",
  d: "M30 24H12M20 30.488h-8M35.994 30.488h-8"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-width": "2",
  d: "M24.003 14.519c-9.686 0-16.48 2.927-18.162 5.588v-6.386c.336-1.33 2.018-3.992 6.054-3.992H36.11c2.018 0 6.054.798 6.054 3.992v6.386c-2.354-2.66-8.475-5.588-18.162-5.588Z"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }